// 导入所有 common 模块的国际化文件
import { messages as storeInfoManageMessages } from '@/lang/common/storeInfoManageLang.js'
import { messages as resourceStoreMessages } from '@/lang/common/resourceStoreLang.js'
import { messages as resourceOutManageMessages } from '@/lang/common/resourceOutManageLang.js'
import { messages as resourceEnterManageMessages } from '@/lang/common/resourceEnterManageLang.js'
import { messages as resourceEnterDetailManageMessages } from '@/lang/common/resourceEnterDetailManageLang.js'
import { messages as purchaseApplyManageMessages } from '@/lang/common/purchaseApplyManageLang.js'
import { messages as purchaseApplyDetailMessages } from '@/lang/common/purchaseApplyDetailLang.js'
import { messages as orgCommunityMessages } from '@/lang/common/orgCommunityLang.js'
import { messages as noticeMessages } from '@/lang/common/noticeLang.js'
import { messages as noticeDetailMessages } from '@/lang/common/noticeDetailLang.js'
import { messages as myAuditHistoryComplaintsMessages } from '@/lang/common/myAuditHistoryComplaintsLang.js'
import { messages as myAuditComplaintsMessages } from '@/lang/common/myAuditComplaintsLang.js'
import { messages as itemOutMessages } from '@/lang/common/itemOutLang.js'
import { messages as enterCommunityMessages } from '@/lang/common/enterCommunityLang.js'
import { messages as complaintManageMessages } from '@/lang/common/complaintManageLang.js'
import { messages as companyMessages } from '@/lang/common/companyLang.js'
import { messages as communityManageMessages } from '@/lang/common/communityManageLang.js'
import { messages as auditUserMessages } from '@/lang/common/auditUserLang.js'
import { messages as auditEnterCommunityManageMessages } from '@/lang/common/auditEnterCommunityManageLang.js'
import { messages as advertVedioViewMessages } from '@/lang/common/advertVedioViewLang.js'
import { messages as purchaseMessages } from '@/lang/common/purchaseLang.js'
import { messages as complaintMessages } from '@/lang/common/complaintLang.js'
import { messages as addAuditUserStepMessages } from '@/lang/common/addAuditUserStepLang.js'

// 合并所有国际化消息
export const messages = {
    en: {
        ...storeInfoManageMessages.en,
        ...resourceStoreMessages.en,
        ...resourceOutManageMessages.en,
        ...resourceEnterManageMessages.en,
        ...resourceEnterDetailManageMessages.en,
        ...purchaseApplyManageMessages.en,
        ...purchaseApplyDetailMessages.en,
        ...orgCommunityMessages.en,
        ...noticeMessages.en,
        ...noticeDetailMessages.en,
        ...myAuditHistoryComplaintsMessages.en,
        ...myAuditComplaintsMessages.en,
        ...itemOutMessages.en,
        ...enterCommunityMessages.en,
        ...complaintManageMessages.en,
        ...companyMessages.en,
        ...communityManageMessages.en,
        ...auditUserMessages.en,
        ...auditEnterCommunityManageMessages.en,
        ...advertVedioViewMessages.en,
        ...purchaseMessages.en,
        ...complaintMessages.en,
        ...addAuditUserStepMessages.en
    },
    zh: {
        ...storeInfoManageMessages.zh,
        ...resourceStoreMessages.zh,
        ...resourceOutManageMessages.zh,
        ...resourceEnterManageMessages.zh,
        ...resourceEnterDetailManageMessages.zh,
        ...purchaseApplyManageMessages.zh,
        ...purchaseApplyDetailMessages.zh,
        ...orgCommunityMessages.zh,
        ...noticeMessages.zh,
        ...noticeDetailMessages.zh,
        ...myAuditHistoryComplaintsMessages.zh,
        ...myAuditComplaintsMessages.zh,
        ...itemOutMessages.zh,
        ...enterCommunityMessages.zh,
        ...complaintManageMessages.zh,
        ...companyMessages.zh,
        ...communityManageMessages.zh,
        ...auditUserMessages.zh,
        ...auditEnterCommunityManageMessages.zh,
        ...advertVedioViewMessages.zh,
        ...purchaseMessages.zh,
        ...complaintMessages.zh,
        ...addAuditUserStepMessages.zh
    }
}
